export default {
  images: [],
}
